/**
 * The translation key for a refused audience import, from the refusal's code. Anything else, such as
 * a file that doesn't parse or a failed request, gets the generic failure.
 */
const KEY_BY_CODE = {
  'audience-storage-full': 'AudienceImport.storageFull',
  'audience-no-email-column': 'AudienceImport.noEmailColumn',
};

export const audienceImportErrorKey = error =>
  KEY_BY_CODE[error?.code] || 'ContactDetailsForm.genericFailure';
